import { render, staticRenderFns } from "./AttendancePunch.vue?vue&type=template&id=724065bb&scoped=true"
import script from "./AttendancePunch.vue?vue&type=script&lang=js"
export * from "./AttendancePunch.vue?vue&type=script&lang=js"
import style0 from "./AttendancePunch.vue?vue&type=style&index=0&id=724065bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724065bb",
  null
  
)

export default component.exports